import React, { forwardRef } from 'react'
import { useTheme } from '@mui/material'
import FormHelperText from '@mui/material/FormHelperText'
import ReCAPTCHA from 'react-google-recaptcha'
import useWindowDimensions from './WindowDimesnions'
import constants from '../../config/constants'

export const GoogleReCaptcha = forwardRef((props, ref) => {
  const theme = useTheme()
  const { width } = useWindowDimensions()
  const { error, errorColor, errorCenter } = props
  const captchaSiteKey = constants.google_reCapcha_site_key

  return (
    <>
      <ReCAPTCHA 
        size={ width >= constants.smBreakpoint ? 'normal' : 'compact' } 
        style={{ width: '100%' }} 
        sitekey={captchaSiteKey} 
        ref={ref}
      />
      {
        error && 
        <FormHelperText
          style={{
            color: errorColor ? errorColor : theme.palette.error.main,
            textAlign: errorCenter ? 'center' : 'left',
          }}
        >
          Invalid reCaptcha!
        </FormHelperText>
      }
    </>
  )
})

export const googleReCaptchaValidation = async (token) => {
  const captchaSecretKey = constants.google_reCapcha_secret_key

  const response = await fetch(
    `${constants.google_reCapcha_url}?secret=${captchaSecretKey}&response=${token}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    }
  )
  
  if (!response.ok) {
      const resErrData = await response.json()
      console.log(resErrData)
      } else {
      const resData = await response.json()
      return resData.success
  }
}